import React from 'react';
import { styled } from '@mui/system';
import { ContentCopy as ContentCopyIcon } from '@mui/icons-material';

interface Props {
  fieldId: string;
  label?: string;
  onClick: (e: any) => any;
  unclickable?: boolean;
}

interface IStyledIcon {
  label?: string;
  unclickable?: boolean;
}

const StyledButton = styled('button')<IStyledIcon>`
  border: none;
  background: none;
  padding: 0;
  outline: none !important;
  border-radius: 4px;
  &:hover {
    cursor: ${(props: IStyledIcon): string => (!props.unclickable ? 'pointer' : 'not-allowed')};
    text-decoration: ${(props: IStyledIcon): string => (!props.unclickable ? 'underline' : 'none')};
  }
`;

const DuplicateIcon = styled(ContentCopyIcon)<IStyledIcon>`
  margin-right: ${(props: IStyledIcon): string => (props.label ? '8px' : '0px')};
  height: 18px;
  width: 18px;
  path {
    fill: ${(props): string => (!props.unclickable ? props.theme.palette.primary.main : 'black')};
    fill-opacity: ${(props: IStyledIcon): string => (!props.unclickable ? '1' : '0.54')};
  }
`;

const Label = styled('span')<IStyledIcon>`
  font-weight: bold;
  font-size: 0.875rem;
  color: ${(props: IStyledIcon): string =>
    !props.unclickable ? 'black' : `${(props: any) => props.theme.palette.grey[600]}`};
`;

const DuplicateButton = ({ fieldId, label, onClick, unclickable }: Props): JSX.Element => {
  return (
    <div id={`${fieldId}-wrapper`}>
      <StyledButton type="button" onClick={onClick} data-test-id={`${fieldId}-button-id`} unclickable={unclickable}>
        <DuplicateIcon label={label} unclickable={unclickable} />
        <Label unclickable={unclickable}>Duplicate</Label>
      </StyledButton>
    </div>
  );
};

export default DuplicateButton;
